// Types
import { GetStream_stream } from 'api/streams/types/GetStream';
import { StreamStatus } from 'api/graphql-global-types';
// Helpers
import { isStoreOwner } from 'helpers/user';
import { getStreamVideoDetails } from 'helpers/streams';
// Hooks
import { useGetCurrUser } from 'hooks';
// Components
import VideoHeader from 'components/common3/VideoHeader/VideoHeader';
import StreamFanActionButtons from './StreamFanActionButtons/StreamFanActionButtons';
import StreamOwnerActionButtons from './StreamOwnerActionButtons/StreamOwnerActionButtons';
import VideoDetails from 'components/common3/VideoDetails/VideoDetails';

type FinishedStreamInfoProps = {
  stream: GetStream_stream;
  onTipModalToggle: () => void;
};

const FinishedStreamInfo = ({
  stream,
  onTipModalToggle,
}: FinishedStreamInfoProps): JSX.Element => {
  const { data: userData } = useGetCurrUser();
  const isStreamEnded = stream.streamStatus === StreamStatus.Ended;
  const isOwner = isStoreOwner(userData, stream.store?.id);
  const videoDetails = getStreamVideoDetails(stream);

  return (
    <>
      <VideoHeader
        title={stream.name || ''}
        store={stream.store}
        isOwner={isOwner}
        actionButtons={
          isOwner ? (
            <StreamOwnerActionButtons stream={stream} />
          ) : (
            <StreamFanActionButtons
              stream={stream}
              isStreamEnded={isStreamEnded}
              onTipModalToggle={onTipModalToggle}
            />
          )
        }
      />

      <VideoDetails
        videoDetails={videoDetails}
        showDisclaimer={!stream.isFree && !stream.isInterview}
      />
    </>
  );
};

export default FinishedStreamInfo;
